(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ama-faq-item').forEach((item) => {
    const summary = item.querySelector('.ama-faq-item__q');
    if (!summary) return;
    summary.addEventListener('click', (evt) => {
      evt.preventDefault();
      const isOpen = item.hasAttribute('open');
      document.querySelectorAll('.ama-faq-item[open]').forEach((openItem) => {
        if (openItem !== item) openItem.removeAttribute('open');
      });
      if (isOpen) {
        item.removeAttribute('open');
      } else {
        item.setAttribute('open', '');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-buy-panel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-buy-panel')) {
    customElements.define(
      'hero-buy-panel',
      class HeroBuyPanel extends HTMLElement {
        connectedCallback() {
          this.rows = Array.from(this.querySelectorAll('[data-flavor-row]'));
          this.ctaBtn = this.querySelector('[data-cta-btn]');
          this.minTins = parseInt(this.dataset.minTins, 10) || 3; // bundle discount starts here
          this.minOrder = parseInt(this.dataset.minOrder, 10) || 0; // fewer tins cannot be bought
          this.discountPct = parseFloat(this.dataset.discountPct || '0');
          this.savingsLine = this.querySelector('[data-savings-line]');
          this.tierEls = Array.from(this.querySelectorAll('[data-tiers] .ama-tier'));
          this.tierCount = this.querySelector('[data-tier-count]');
          this.summary = {
            goal: this.querySelector('.ama-summary__goal'),
            text: this.querySelector('[data-goal-text]'),
            badge: this.querySelector('[data-goal-badge]'),
            full: this.querySelector('[data-sum-full]'),
            price: this.querySelector('[data-sum-price]'),
            saveBox: this.querySelector('[data-sum-save-box]'),
            save: this.querySelector('[data-sum-save]'),
            free: this.querySelector('[data-sum-free]'),
          };
          this.prevUnlocked = null;
          this.cartPaid = 0; // tins already in the cart (rewards excluded)
          this.flash = '';
          this.freeTinBox = this.querySelector('[data-freetin]');
          this.status = '';
          this.state = { qty: 0, price: 0, full: 0, codeActive: false };

          this.rows.forEach((row) => {
            const stepper = row.querySelector('[data-stepper]');
            if (!stepper) return;
            const inc = stepper.querySelector('[data-increment]');
            const dec = stepper.querySelector('[data-decrement]');
            inc.addEventListener('click', () => this.changeQty(row, 1));
            dec.addEventListener('click', () => this.changeQty(row, -1));
          });

          if (this.ctaBtn) this.ctaBtn.addEventListener('click', () => this.addToCart());
          if (this.freeTinBox) this.freeTinBox.addEventListener('change', () => this.render());

          this.initStickyBar();
          this.render();
          document.addEventListener('ama:promo-change', () => this.render());
          document.addEventListener('ama:cart-synced', (e) => this.setCartPaid(e.detail));
          this.refreshCart();
        }

        // Tins already in the cart count toward the order minimum, so someone
        // who has 3+ can add one at a time. Free reward lines are not counted.
        setCartPaid(cart) {
          if (!cart || !Array.isArray(cart.items)) return;
          const paid = window.AmaRewards ? window.AmaRewards.paidCount(cart) : cart.items.reduce((n, i) => n + i.quantity, 0);
          if (paid === this.cartPaid) return;
          const first = !this.cartKnown;
          this.cartKnown = true;
          this.cartPaid = paid;
          // Visitor already holds a valid order: drop the preselected tins.
          if (first && paid >= this.minOrder) {
            this.rows.forEach((row) => {
              const c = row.querySelector('[data-count]');
              if (c) c.textContent = '0';
            });
          }
          this.render();
        }

        refreshCart() {
          return fetch('/cart.js', { credentials: 'same-origin' })
            .then((r) => r.json())
            .then((cart) => this.setCartPaid(cart))
            .catch(() => {});
        }

        // Fewest tins that can be added right now.
        required() {
          return Math.max(1, this.minOrder - this.cartPaid);
        }

        money(cents) {
          return `$${(cents / 100).toFixed(2)}`;
        }

        initStickyBar() {
          this.stickyBar = this.querySelector('[data-sticky-bar]');
          if (!this.stickyBar || !this.ctaBtn) return;
          this.stickySelect = this.stickyBar.querySelector('[data-sticky-select]');
          this.stickyCta = this.stickyBar.querySelector('[data-sticky-cta]');
          document.body.classList.add('ama-has-bar');

          this.stickySelect.addEventListener('change', () => this.setTotal(parseInt(this.stickySelect.value, 10) || 0));
          this.stickyCta.addEventListener('click', () => {
            const { qty } = this.state;
            if (qty === 0 || qty < this.required()) {
              this.scrollToFlavors();
              return;
            }
            this.addToCart();
          });
        }

        // Set the total number of tins from the bar's menu, keeping the flavor mix balanced.
        setTotal(n) {
          const rows = this.rows.filter((r) => r.querySelector('[data-stepper]'));
          if (!rows.length) return;
          const get = (r) => parseInt(r.querySelector('[data-count]').textContent, 10) || 0;
          const put = (r, v) => {
            r.querySelector('[data-count]').textContent = v;
            r.classList.toggle('is-selected', v > 0);
          };
          let total = rows.reduce((sum, r) => sum + get(r), 0);
          while (total < n) {
            const r = rows.reduce((a, b) => (get(b) < get(a) ? b : a));
            put(r, get(r) + 1);
            total += 1;
          }
          while (total > n) {
            const r = rows.reduce((a, b) => (get(b) > get(a) ? b : a));
            if (get(r) === 0) break;
            put(r, get(r) - 1);
            total -= 1;
          }
          this.render();
        }

        scrollToFlavors() {
          const rows = this.querySelector('.ama-selection-rows');
          if (!rows) return;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          rows.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        }

        changeQty(row, delta) {
          const countEl = row.querySelector('[data-count]');
          const next = Math.max(0, parseInt(countEl.textContent, 10) + delta);
          countEl.textContent = next;
          row.classList.toggle('is-selected', next > 0);
          this.render();
        }

        totals() {
          let qty = 0;
          const lines = this.rows.map((row) => {
            const countEl = row.querySelector('[data-count]');
            const n = countEl ? parseInt(countEl.textContent, 10) : 0;
            qty += n;
            return { n, unitPrice: parseFloat(row.dataset.price || '0') };
          });

          const applyDiscount = qty + this.cartPaid >= this.minTins && this.discountPct > 0;
          const promo = window.AmaPromo;
          const codeActive = !!(promo && promo.percent());
          let price = 0;
          let full = 0;
          lines.forEach(({ n, unitPrice }) => {
            full += n * unitPrice;
            let unit = unitPrice;
            if (applyDiscount) {
              // Shopify's percentage discount engine floors the per-unit
              // discount to the nearest cent, so mirror that exactly.
              unit -= Math.floor(unit * (this.discountPct / 100));
            }
            price += n * unit;
          });
          // A claimed spin-wheel code is an order-level discount that comes
          // off the subtotal after the bundle discount.
          if (codeActive) price = promo.totalAfterCode(price);

          const pct = full > 0 ? Math.round(((full - price) / full) * 100) : 0;
          return { qty, price, full, codeActive, pct };
        }

        setCta(label, priceHtml, disabled) {
          this.ctaBtn.innerHTML =
            `<span class="ama-cta__label">${label}</span>` + (priceHtml ? `<span class="ama-cta__price">${priceHtml}</span>` : '');
          this.ctaBtn.disabled = disabled;
        }

        setStatus(text, resetMs) {
          this.status = text;
          this.render();
          if (resetMs) {
            setTimeout(() => {
              this.status = '';
              this.render();
            }, resetMs);
          }
        }

        render() {
          if (!this.ctaBtn) return;
          const t = this.totals();
          this.state = t;
          const { qty, price, full } = t;
          const s = (n) => (n === 1 ? '' : 's');
          const eff = qty + this.cartPaid; // tins in the order once this add lands
          this.rows.forEach((row) => {
            const c = row.querySelector('[data-count]');
            if (c) row.classList.toggle('is-selected', parseInt(c.textContent, 10) > 0);
          });
          this.renderTiers(eff);
          this.renderFreeTin(eff);
          this.renderSummary(t);
          this.renderSavings(t);

          const belowMin = qty > 0 && qty < this.required();
          if (this.status) {
            this.setCta(this.status, '', true);
          } else if (qty === 0) {
            this.setCta(window.ama_i18n?.selectFlavor || 'Select Your Flavors', '', true);
          } else if (belowMin) {
            const need = this.required() - qty;
            this.setCta(`Add ${need} more tin${s(need)}`, '', true);
          } else {
            const priceHtml = (full > price ? `<s>${this.money(full)}</s>` : '') + `<b>${this.money(price)}</b>`;
            this.setCta(`Add ${qty} Tin${s(qty)} To Cart`, priceHtml, false);
          }
          this.syncStickyBar();
        }

        syncStickyBar() {
          if (!this.stickyBar) return;
          const { qty, price, full } = this.state;
          const s = (n) => (n === 1 ? '' : 's');
          // The menu always shows the current number of tins.
          if (!this.stickySelect.querySelector(`option[value="${qty}"]`)) {
            const opt = document.createElement('option');
            opt.value = String(qty);
            opt.textContent = `${qty} Tin${s(qty)}`;
            this.stickySelect.appendChild(opt);
          }
          this.stickySelect.value = String(qty);

          let label;
          let priceHtml = '';
          if (this.status) {
            label = this.status;
          } else if (qty === 0) {
            label = 'Choose your tins';
          } else if (qty < this.required()) {
            const need = this.required() - qty;
            label = `Add ${need} more tin${s(need)}`;
          } else {
            label = 'Add to Cart';
            priceHtml = (full > price ? `<s>${this.money(full)}</s>` : '') + `<b>${this.money(price)}</b> <i aria-hidden="true">→</i>`;
          }
          this.stickyCta.innerHTML =
            `<span class="ama-sticky-bar__label">${label}</span>` + (priceHtml ? `<span class="ama-sticky-bar__price">${priceHtml}</span>` : '');
          this.stickyCta.disabled = !!this.status;
        }

        renderTiers(qty) {
          if (!this.tierEls.length) return;
          const unlockedNames = [];
          this.tierEls.forEach((el) => {
            const on = qty > 0 && qty >= parseInt(el.dataset.at, 10);
            el.classList.toggle('is-unlocked', on);
            if (on) unlockedNames.push(el.dataset.name);
          });
          if (this.tierCount) this.tierCount.textContent = `${unlockedNames.length}/${this.tierEls.length}`;
          // Celebrate a reward that just unlocked (not on first paint).
          if (this.prevUnlocked) {
            const fresh = unlockedNames.filter((n) => !this.prevUnlocked.includes(n));
            if (fresh.length) {
              this.flash = fresh[fresh.length - 1];
              clearTimeout(this.flashTimer);
              this.flashTimer = setTimeout(() => {
                this.flash = '';
                this.render();
              }, 3200);
            }
          }
          this.prevUnlocked = unlockedNames;
        }

        renderSummary(t) {
          const el = this.summary;
          if (!el || !el.text) return;
          const { qty, price, full, pct } = t;
          const eff = qty + this.cartPaid;
          const tins = (n) => `${n} tin${n === 1 ? '' : 's'}`;
          let next = null;
          this.tierEls.forEach((tier) => {
            const at = parseInt(tier.dataset.at, 10);
            if (eff >= at && eff > 0) return;
            if (!next || at < parseInt(next.dataset.at, 10)) next = tier;
          });

          let goal;
          let badge;
          if (this.flash && eff > 0) {
            goal = 'Unlocked:';
            badge = this.flash;
          } else if (next) {
            const need = parseInt(next.dataset.at, 10) - eff;
            goal = eff === 0 ? `Add ${tins(need)} to get` : `Add ${need} more to get`;
            badge = next.dataset.name + (next.dataset.name.includes('% off') ? ' today' : '');
          } else {
            goal = 'Every reward unlocked';
            badge = 'max savings';
          }
          el.text.textContent = goal;
          el.badge.textContent = badge;
          el.goal.classList.toggle('is-flash', !!this.flash && eff > 0);

          if (qty === 0) {
            el.full.textContent = '';
            el.price.textContent = '';
            el.saveBox.hidden = true;
          } else if (qty < this.required()) {
            el.full.textContent = '';
            el.price.textContent = this.money(full);
            el.price.classList.add('is-muted');
            el.saveBox.hidden = true;
          } else {
            el.price.classList.remove('is-muted');
            el.full.textContent = full > price ? this.money(full) : '';
            el.price.textContent = this.money(price);
            el.saveBox.hidden = !(full > price);
            if (full > price) el.save.textContent = `${this.money(full - price)} (${pct}%)`;
          }

          // Free items that are included at this quantity.
          const free = [];
          const unlocked = (name) => this.tierEls.some((tier) => tier.dataset.name === name && eff >= parseInt(tier.dataset.at, 10));
          if (qty > 0 && unlocked('a free tin')) {
            const chosen = this.freeTinBox && this.freeTinBox.querySelector('input:checked');
            free.push(`Free: 1 ${chosen ? chosen.value : ''} tin`.replace('  ', ' '));
          }
          if (qty > 0 && unlocked('a free mystery gift')) free.push('Free: mystery gift');
          el.free.innerHTML = free.map((f) => `<li>${f}</li>`).join('');
          el.free.hidden = free.length === 0;
        }

        renderFreeTin(qty) {
          if (!this.freeTinBox) return;
          const at = (this.tierEls.find((el) => el.dataset.name === 'a free tin') || {}).dataset;
          this.freeTinBox.hidden = !(at && qty >= parseInt(at.at, 10));
        }

        renderSavings(t) {
          if (!this.savingsLine) return;
          const { qty, codeActive } = t;
          const parts = [];
          const eff = qty + this.cartPaid;
          if (this.cartPaid > 0) parts.push(`${this.cartPaid} tin${this.cartPaid === 1 ? '' : 's'} already in your cart`);
          if (qty > 0 && codeActive && window.AmaPromo.code()) parts.push(`${window.AmaPromo.code()} applied`);
          const shipUnlocked = this.tierEls.some((el) => el.dataset.name === 'free shipping' && eff >= parseInt(el.dataset.at, 10));
          if (qty > 0 && shipUnlocked) parts.push('Free shipping unlocked');
          this.savingsLine.innerHTML = parts.join(' · ');
          this.savingsLine.hidden = parts.length === 0;
        }

        async addToCart() {
          if (this.ctaBtn.disabled) return;
          const items = this.rows
            .map((row) => {
              const countEl = row.querySelector('[data-count]');
              const quantity = countEl ? parseInt(countEl.textContent, 10) : 0;
              return { id: parseInt(row.dataset.variantId, 10), quantity };
            })
            .filter((item) => item.quantity > 0);
          if (!items.length) return;
          const paid = items.reduce((sum, i) => sum + i.quantity, 0);
          if (paid < this.required()) return;

          // Free tin / mystery gift lines for the reached tiers.
          if (window.AmaRewards) {
            const chosen = this.freeTinBox && this.freeTinBox.querySelector('input:checked');
            items.push(...window.AmaRewards.rewardItems(paid + this.cartPaid, chosen ? chosen.value : ''));
          }

          this.setStatus('Adding…');

          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const body = { items };
          if (cart) {
            body.sections = cart.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
            cart.setActiveElement(document.activeElement);
          }

          try {
            const config = fetchConfig();
            config.body = JSON.stringify(body);
            const response = await fetch(window.routes.cart_add_url, config);
            const data = await response.json();

            if (data.status) {
              this.setStatus(data.description || data.message || 'Something went wrong', 2000);
              return;
            }

            if (cart) {
              try {
                // /cart/add.js returns { items: [...] } for a multi-item add,
                // not a single item with a top-level `key` the way Dawn's own
                // single-variant product-form.js expects. Cart notification's
                // renderContents() reads parsedState.key to find which cart
                // line to highlight, so backfill it from the first item added
                // or the cart's most recent line.
                if (data.key === undefined) {
                  if (Array.isArray(data.items) && data.items.length && data.items[0].key) {
                    data.key = data.items[0].key;
                  } else if (cart.cartItemKey) {
                    data.key = cart.cartItemKey;
                  }
                }
                cart.renderContents(data);
                if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
              } catch (renderError) {
                console.error('Cart drawer failed to refresh (item was still added):', renderError);
              }
            } else {
              window.location = window.routes.cart_url;
              return;
            }

            // The cart now holds these tins; start the next pick from zero.
            this.rows.forEach((row) => {
              const c = row.querySelector('[data-count]');
              if (c) c.textContent = '0';
            });
            this.prevUnlocked = null;
            if (window.AmaRewards) window.AmaRewards.sync();
            this.refreshCart();
            this.setStatus('Added ✓', 1400);
          } catch (e) {
            console.error(e);
            this.setStatus('Network error — try again', 2000);
          }
        }
      }
    );
  }


  // Slide 1: pause the floating tins / video when another slide is showing; light mouse parallax on desktop.
  (function () {
    const scenes = document.querySelectorAll('[data-float-scene]');
    const videos = document.querySelectorAll('[data-hero-video]');
    if (!scenes.length && !videos.length) return;
    const track = document.querySelector('[data-hero-slides]');
    const targets = [...scenes, ...videos];
    if ('IntersectionObserver' in window && track) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const on = entry.isIntersecting && entry.intersectionRatio >= 0.55;
            const el = entry.target;
            if (el.hasAttribute('data-float-scene')) el.classList.toggle('is-idle', !on);
            else if (on) el.play && el.play().catch(() => {});
            else el.pause && el.pause();
          });
        },
        { root: track, threshold: [0, 0.55, 1] }
      );
      targets.forEach((t) => io.observe(t));
    }
    const fine = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)');
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    scenes.forEach((scene) => {
      const media = scene.closest('.ama-hero__media') || scene;
      let raf = 0;
      media.addEventListener('pointermove', (e) => {
        if (!fine.matches || calm.matches || e.pointerType === 'touch') return;
        const r = scene.getBoundingClientRect();
        const x = Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width - 0.5) * 2));
        const y = Math.max(-1, Math.min(1, ((e.clientY - r.top) / r.height - 0.5) * 2));
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          scene.style.setProperty('--mx', x.toFixed(3));
          scene.style.setProperty('--my', y.toFixed(3));
        });
      });
      media.addEventListener('pointerleave', () => {
        scene.style.setProperty('--mx', '0');
        scene.style.setProperty('--my', '0');
      });
    });
  })();

  if (!customElements.get('ama-hero-carousel')) {
    document.querySelectorAll('.ama-hero__media').forEach((media) => {
      const wrap = media.querySelector('[data-hero-slides]');
      const dots = media.querySelectorAll('[data-hero-dots] span');
      const prevBtn = media.querySelector('[data-hero-prev]');
      const nextBtn = media.querySelector('[data-hero-next]');
      if (!wrap) return;
      const count = wrap.children.length;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function goTo(i) {
        i = Math.max(0, Math.min(count - 1, i));
        wrap.scrollTo({ left: wrap.clientWidth * i, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      function current() {
        return Math.round(wrap.scrollLeft / wrap.clientWidth);
      }
      dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));
      if (prevBtn) prevBtn.addEventListener('click', () => goTo(current() - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => goTo(current() + 1));
      wrap.addEventListener('scroll', () => {
        window.requestAnimationFrame(() => {
          const idx = current();
          dots.forEach((d, i) => d.classList.toggle('active', i === idx));
        });
      });

      let isDown = false, startX, startScroll;
      wrap.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX;
        startScroll = wrap.scrollLeft;
        wrap.style.scrollSnapType = 'none';
      });
      window.addEventListener('mouseup', () => {
        if (!isDown) return;
        isDown = false;
        wrap.style.scrollSnapType = 'x mandatory';
        goTo(current());
      });
      window.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        wrap.scrollLeft = startScroll - (e.pageX - startX);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spin-wheel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spin-wheel')) {
    customElements.define(
      'spin-wheel',
      class SpinWheel extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;

          try {
            this.cfg = JSON.parse(this.querySelector('[data-wheel-config]').textContent);
          } catch (e) {
            return;
          }
          this.key = 'ama_wheel_v1';
          this.overlay = this.querySelector('[data-wheel-overlay]');
          this.tab = this.querySelector('[data-wheel-tab]');
          this.disc = this.querySelector('[data-wheel-disc]');
          this.form = this.querySelector('form');
          this.requireEmail = this.dataset.requireEmail === 'true';
          this.spinning = false;

          this.detectAdOffer();
          if (!this.cfg.slices || this.cfg.slices.length < 2) {
            this.initAdTab();
            return;
          }
          this.buildWheel();

          this.querySelectorAll('[data-wheel-close]').forEach((b) => b.addEventListener('click', () => this.close()));
          this.overlay.addEventListener('click', (e) => { if (e.target === this.overlay) this.close(); });
          this.tab.addEventListener('click', () => this.onTab());
          this.querySelector('[data-wheel-copy]').addEventListener('click', () => this.copyCode());
          this.querySelector('[data-wheel-spin]').addEventListener('click', () => this.spin());
          this.form.addEventListener('submit', (e) => { e.preventDefault(); this.claim(); });
          this.pointer = this.querySelector('[data-wheel-pointer]');
          this.overlay.addEventListener('keydown', (e) => this.onKey(e));

          const state = this.read();
          const forced = /[?&]spin=1(&|$)/.test(window.location.search);
          const cooldownMs = (parseFloat(this.dataset.cooldown) || 3) * 86400000;

          if (forced) {
            setTimeout(() => this.open(), 400);
          } else if (state && state.prize && state.prize.source === 'ad') {
            // Arrived from the ad: no wheel, just a small "offer applied" tab.
            this.initAdTab();
          } else if (state && state.prize) {
            this.showResult(state.prize);
            this.setTab(this.tabTextFor(state.prize));
          } else if (state && state.closedAt && Date.now() - state.closedAt < cooldownMs) {
            this.setTab(this.tab.querySelector('[data-wheel-tab-label]').textContent);
          } else if (!(window.Shopify && window.Shopify.designMode)) {
            const delay = Math.max(0, parseFloat(this.dataset.delay) || 0) * 1000;
            setTimeout(() => { if (!this.spinning && this.overlay.hidden) this.open(); }, delay);
          }
        }

        tabTextFor(prize) {
          return prize.claimed ? 'Your gift: ' + prize.label : 'Claim your ' + prize.label;
        }

        read() {
          try {
            const s = JSON.parse(localStorage.getItem(this.key));
            if (s && s.prize && s.prize.expires && s.prize.expires < Date.now()) {
              localStorage.removeItem(this.key);
              return null;
            }
            return s;
          } catch (e) { return null; }
        }

        // Visitors who arrive through the ad link (?offer=meta by default) get
        // the ad discount instead of the wheel. It is saved in the same place
        // as a claimed wheel prize, so the site shows the code price.
        detectAdOffer() {
          const ad = this.cfg.ad;
          if (!ad || !ad.enabled || !ad.code || !ad.param) return;
          let match = false;
          try { match = new URLSearchParams(window.location.search).get(ad.param) === ad.value; } catch (e) {}
          if (!match) return;
          const percent = Number(ad.percent) || 0;
          const prize = {
            label: percent + '% OFF',
            prizeName: percent + '% off your order',
            code: ad.code,
            percent: percent,
            variantId: null,
            claimed: true,
            source: 'ad',
            expires: Date.now() + (Number(ad.days) || 14) * 86400000,
          };
          this.write({ prize: prize, wonAt: Date.now() });
          // Belt and braces: the ad link normally applies the code already.
          try { fetch('/discount/' + encodeURIComponent(ad.code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }); } catch (e) {}
          // The price helper may have started before this ran; tell it to refresh.
          if (window.AmaPromo) window.AmaPromo.notify();
        }

        initAdTab() {
          const state = this.read();
          if (!state || !state.prize || state.prize.source !== 'ad') return;
          this.setTab(state.prize.percent + '% off applied');
        }

        onTab() {
          const state = this.read();
          if (state && state.prize && state.prize.source === 'ad') {
            const label = this.tab.querySelector('[data-wheel-tab-label]');
            const old = label.textContent;
            const done = () => { label.textContent = 'Code ' + state.prize.code + ' copied'; setTimeout(() => (label.textContent = old), 2000); };
            if (navigator.clipboard) navigator.clipboard.writeText(state.prize.code).then(done, () => {});
            return;
          }
          this.open();
        }
        write(data) {
          try { localStorage.setItem(this.key, JSON.stringify(data)); } catch (e) {}
        }
        setTab(text) {
          this.tab.querySelector('[data-wheel-tab-label]').textContent = text;
          this.tab.hidden = false;
        }

        buildWheel() {
          const slices = this.cfg.slices;
          const n = slices.length;
          const a = 360 / n;
          const R = 150;
          const fills = [['#0B1118', '#FFFFFF'], ['#CDF1C7', '#040404']];
          const pt = (deg, r) => {
            const t = (deg * Math.PI) / 180;
            return [(r * Math.sin(t)).toFixed(2), (-r * Math.cos(t)).toFixed(2)];
          };
          let svg = '<svg viewBox="-160 -160 320 320" xmlns="http://www.w3.org/2000/svg" focusable="false">';
          svg += '<circle r="158" fill="#040404"/>';
          slices.forEach((s, i) => {
            const [c, t] = n % 2 && i === n - 1 ? ['#A6ED98', '#040404'] : fills[i % 2];
            const [x1, y1] = pt(i * a, R);
            const [x2, y2] = pt((i + 1) * a, R);
            svg += `<path d="M0 0L${x1} ${y1}A${R} ${R} 0 0 1 ${x2} ${y2}Z" fill="${c}"/>`;
            const mid = i * a + a / 2;
            const words = String(s.label).toUpperCase().split(' ');
            const lines = words.length > 1 && s.label.length > 8 ? [words[0], words.slice(1).join(' ')] : [words.join(' ')];
            const size = lines.some((l) => l.length > 7) ? 15 : 19;
            svg += `<g transform="rotate(${mid - 90})"><text x="${R * 0.6}" y="0" text-anchor="middle" fill="${t}" font-family="Titillium Web, sans-serif" font-weight="700" font-size="${size}" letter-spacing="0.5">`;
            lines.forEach((l, li) => {
              const dy = lines.length === 1 ? size * 0.35 : (li === 0 ? -size * 0.15 : size * 1.05);
              svg += `<tspan x="${R * 0.6}" dy="${li === 0 ? dy : size * 1.1}">${l.replace(/&/g, '&amp;').replace(/</g, '&lt;')}</tspan>`;
            });
            svg += '</text></g>';
          });
          svg += '<circle r="26" fill="#F5F5F5" stroke="#040404" stroke-width="4"/>';
          svg += '<circle r="6" fill="#682959"/></svg>';
          this.disc.innerHTML = svg;
        }

        open() {
          if (this.opening) return;
          const forced = /[?&]spin=1(&|$)/.test(window.location.search);
          const state = forced ? null : this.read();
          if (state && state.prize) this.showResult(state.prize);
          else this.showIntro();
          this.overlay.hidden = false;
          this.tab.hidden = true;
          document.body.classList.add('ama-wheel-open');
          this.lastFocus = document.activeElement;
          const target = state && state.prize ? this.overlay.querySelector('[data-wheel-result-title]') : this.overlay.querySelector('[data-wheel-spin]');
          if (target) target.focus({ preventScroll: true });
        }

        close() {
          if (this.spinning) return;
          this.overlay.hidden = true;
          document.body.classList.remove('ama-wheel-open');
          const state = this.read() || {};
          if (!state.prize) {
            state.closedAt = Date.now();
            this.write(state);
            this.setTab(this.tab.querySelector('[data-wheel-tab-label]').textContent);
          } else {
            this.setTab(this.tabTextFor(state.prize));
          }
          if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
        }

        onKey(e) {
          if (e.key === 'Escape') { this.close(); return; }
          if (e.key !== 'Tab') return;
          const f = Array.from(this.overlay.querySelectorAll('button, input, a[href]')).filter((el) => el.offsetParent !== null && !el.disabled);
          if (!f.length) return;
          const first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }

        showIntro() {
          this.querySelector('[data-wheel-view="form"]').hidden = false;
          this.querySelector('[data-wheel-view="result"]').hidden = true;
          this.disc.style.transition = 'none';
          this.disc.style.transform = 'rotate(0deg)';
          this.querySelector('[data-wheel-spin]').disabled = false;
        }

        spin() {
          if (this.spinning) return;
          const forced = /[?&]spin=1(&|$)/.test(window.location.search);
          const existing = this.read();
          if (existing && existing.prize && !forced) { this.showResult(existing.prize); return; }

          this.spinning = true;
          this.querySelector('[data-wheel-spin]').disabled = true;
          const idx = this.pick();
          const prize = this.cfg.slices[idx];
          const n = this.cfg.slices.length;
          const a = 360 / n;
          const jitter = (Math.random() - 0.5) * a * 0.6;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const turns = reduce ? 1 : 6;
          const target = turns * 360 + (360 - (idx * a + a / 2)) + jitter;
          const ms = reduce ? 1200 : 5600;
          const saved = { label: prize.label, prizeName: prize.prize, code: prize.code, percent: prize.percent, variantId: prize.variantId, claimed: false };

          // Save the result up front so a refresh mid-spin cannot re-roll it.
          this.write({ prize: saved, wonAt: Date.now() });

          this.disc.style.transition = `transform ${ms}ms cubic-bezier(0.12, 0.6, 0.1, 1)`;
          if (this.pointer && !reduce) this.pointer.classList.add('is-flicking');
          requestAnimationFrame(() => { this.disc.style.transform = `rotate(${target}deg)`; });
          // Slow the pointer flick as the wheel settles.
          if (this.pointer && !reduce) setTimeout(() => this.pointer.classList.remove('is-flicking'), ms - 1400);
          setTimeout(() => this.finish(saved), ms + 250);
        }

        async finish(saved) {
          this.spinning = false;
          if (this.pointer) this.pointer.classList.remove('is-flicking');
          this.showResult(saved, true);
          // No email asked for: the prize is claimed straight away.
          if (!this.requireEmail) await this.completeClaim(saved);
        }

        async claim() {
          if (this.spinning) return;
          const state = this.read();
          if (!state || !state.prize || state.prize.claimed) return;

          const err = this.querySelector('[data-wheel-error]');
          if (this.requireEmail) {
            const input = this.querySelector('.ama-wheel__input');
            const ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim());
            if (err) err.hidden = ok;
            if (!ok) { input.focus(); return; }
            this.querySelector('[data-wheel-claim-btn]').disabled = true;
            // Best effort: a failed email save should not cost them the prize.
            try { await fetch(this.form.action, { method: 'POST', body: new FormData(this.form), credentials: 'same-origin' }); } catch (e) {}
          }
          await this.completeClaim(state.prize);
        }

        async completeClaim(prize) {
          await this.applyPrize(prize);
          const claimed = Object.assign({}, prize, { claimed: true });
          this.write({ prize: claimed, wonAt: (this.read() || {}).wonAt || Date.now() });
          this.showResult(claimed, true);
          if (window.AmaPromo) window.AmaPromo.notify();
        }

        pick() {
          // Slices marked "Always win" take every spin (random among them);
          // otherwise fall back to the weighted draw below.
          const always = this.cfg.slices.map((x, i) => (x.always ? i : -1)).filter((i) => i >= 0);
          if (always.length) {
            const b = new Uint32Array(1);
            (window.crypto || window.msCrypto).getRandomValues(b);
            return always[b[0] % always.length];
          }
          const w = this.cfg.slices.map((x) => Math.max(0, Number(x.weight) || 0));
          const total = w.reduce((x, y) => x + y, 0);
          const buf = new Uint32Array(1);
          (window.crypto || window.msCrypto).getRandomValues(buf);
          const u = buf[0] / 4294967296;
          if (!total) return Math.floor(u * w.length);
          let r = u * total;
          for (let i = 0; i < w.length; i++) {
            r -= w[i];
            if (r < 0) return i;
          }
          return w.length - 1;
        }

        async applyPrize(prize) {
          if (prize.code) {
            try { await fetch('/discount/' + encodeURIComponent(prize.code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }); } catch (e) {}
          }
          if (prize.variantId) {
            try {
              const res = await fetch(window.routes.cart_add_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: [{ id: prize.variantId, quantity: 1 }], sections: 'cart-icon-bubble' }),
              });
              const data = await res.json();
              const bubble = document.getElementById('cart-icon-bubble');
              if (bubble && data.sections && data.sections['cart-icon-bubble']) {
                const el = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
                if (el) bubble.innerHTML = el.innerHTML;
              }
            } catch (e) {}
          }
        }

        showResult(prize, fresh) {
          this.querySelector('[data-wheel-view="form"]').hidden = true;
          this.querySelector('[data-wheel-view="result"]').hidden = false;
          this.querySelector('[data-wheel-result-title]').textContent = (this.cfg.resultHeading || 'You won') + ' ' + prize.prizeName + '!';
          const claimed = !!prize.claimed;
          this.querySelector('[data-wheel-claim]').hidden = claimed;
          this.querySelector('[data-wheel-done]').hidden = !claimed;
          if (claimed) {
            this.querySelector('[data-wheel-result-text]').textContent = (prize.code ? this.cfg.winBodyCode : this.cfg.winBodyGift) || '';
            this.querySelector('[data-wheel-code-box]').hidden = !prize.code;
            this.querySelector('[data-wheel-code]').textContent = prize.code || '';
          } else {
            this.querySelector('[data-wheel-claim-btn]').disabled = false;
          }
          if (!fresh) {
            this.disc.style.transition = 'none';
            const slices = this.cfg.slices;
            const idx = Math.max(0, slices.findIndex((x) => x.label === prize.label && x.code === prize.code));
            const a = 360 / slices.length;
            this.disc.style.transform = `rotate(${360 - (idx * a + a / 2)}deg)`;
          }
          const title = this.querySelector('[data-wheel-result-title]');
          if (!this.overlay.hidden) title.focus({ preventScroll: true });
        }

        async copyCode() {
          const code = this.querySelector('[data-wheel-code]').textContent;
          const label = this.querySelector('[data-wheel-copy-label]');
          try { await navigator.clipboard.writeText(code); label.textContent = 'Copied'; } catch (e) { label.textContent = 'Press and hold to copy'; }
          setTimeout(() => (label.textContent = 'Copy'), 2000);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonial-video')) {
    customElements.define(
      'testimonial-video',
      class TestimonialVideo extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.playBtn = this.querySelector('.ama-testi-card__play');
          if (!this.video || !this.playBtn) return;

          this.playBtn.addEventListener('click', () => {
            document.querySelectorAll('testimonial-video').forEach((other) => {
              if (other !== this && other.video && !other.video.paused) other.video.pause();
            });
            this.video.controls = true;
            this.classList.add('is-playing');
            const p = this.video.play();
            if (p && p.catch) p.catch(() => this.classList.remove('is-playing'));
          });

          this.video.addEventListener('pause', () => {
            if (this.video.ended || this.video.currentTime === 0) this.reset();
          });
          this.video.addEventListener('ended', () => this.reset());
        }

        reset() {
          this.video.controls = false;
          this.video.currentTime = 0;
          this.classList.remove('is-playing');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
